import { useContext } from "react";
import { VoteContext } from "../context/voteProvider";
import { DaoVoteContext } from "../context/daoVoteProvider";

export const useVotes = () => useContext(VoteContext);
export const useDaoVotes = () => useContext(DaoVoteContext)